(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const form = document.querySelector('.cart__form');
    if (!form) return;

    const cartChangeUrl = (window.Shopify?.routes?.root || '/') + 'cart/change.js';
    let updateTimer;

    const setLoading = (isLoading) => {
      form.classList.toggle('cart__form--loading', isLoading);
      form.querySelectorAll('.quantity__input, .quantity__step, .cart__button').forEach((el) => {
        el.disabled = isLoading;
      });
    };

    const updateLineQuantity = (line, quantity) => {
      setLoading(true);

      fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line, quantity }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
          window.location.reload();
        });
    };

    const scheduleUpdate = (input) => {
      const line = parseInt(input.dataset.index, 10);
      const quantity = Math.max(0, parseInt(input.value, 10) || 0);
      if (!line) return;

      clearTimeout(updateTimer);
      updateTimer = setTimeout(() => updateLineQuantity(line, quantity), 300);
    };

    form.querySelectorAll('.quantity').forEach((quantity) => {
      const input = quantity.querySelector('.quantity__input');
      if (!input) return;

      quantity.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const step = parseInt(button.dataset.quantityStep, 10);
          const min = parseInt(input.min, 10) || 0;
          const current = parseInt(input.value, 10) || min;
          input.value = Math.max(min, current + step);
          scheduleUpdate(input);
        });
      });

      input.addEventListener('change', () => scheduleUpdate(input));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavourtown"] && !Shopify.designMode) return;
  try {
    
  function initFlavourtown(root) {
    if (root.dataset.flavourtownReady === 'true') return;

    const track = root.querySelector('[data-flavourtown-track]');
    const prev = root.querySelector('[data-flavourtown-prev]');
    const next = root.querySelector('[data-flavourtown-next]');
    if (!track || !prev || !next) return;

    root.dataset.flavourtownReady = 'true';

    const getStep = () => {
      const card = track.querySelector('.flavourtown-card');
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initAllFlavourtown() {
    document.querySelectorAll('[data-flavourtown]').forEach(initFlavourtown);
  }

  initAllFlavourtown();

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-flavourtown]');
    if (root) initFlavourtown(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const OPEN_CLASS = 'site-header-menu-open';
    const SCROLL_THRESHOLD = 8;

    function getElements(root) {
      const header = root.querySelector('.site-header');
      if (!header) return null;

      return {
        header,
        toggle: header.querySelector('.site-header__menu-toggle'),
        close: header.querySelector('.site-header__menu-close'),
        drawer: header.querySelector('.site-header__drawer'),
      };
    }

    function setOpen(els, isOpen) {
      els.drawer.hidden = !isOpen;
      els.toggle.setAttribute('aria-expanded', String(isOpen));
      document.documentElement.classList.toggle(OPEN_CLASS, isOpen);

      if (isOpen) {
        els.close.focus();
      } else {
        els.toggle.focus();
      }
    }

    function initScrollReveal(header) {
      if (!header.hasAttribute('data-scroll-reveal')) return;
      if (header.dataset.scrollRevealReady === 'true') return;
      header.dataset.scrollRevealReady = 'true';

      const update = () => {
        header.classList.toggle('is-visible', window.scrollY > SCROLL_THRESHOLD);
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
    }

    function initHeader(root) {
      const els = getElements(root);
      if (!els) return;
      if (els.header.dataset.menuReady === 'true') return;
      els.header.dataset.menuReady = 'true';

      initScrollReveal(els.header);

      if (!els.toggle || !els.close || !els.drawer) return;

      els.toggle.addEventListener('click', () => {
        const isOpen = els.toggle.getAttribute('aria-expanded') === 'true';
        setOpen(els, !isOpen);
      });

      els.close.addEventListener('click', () => {
        setOpen(els, false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (els.drawer.hidden) return;
        setOpen(els, false);
      });
    }

    initHeader(document);

    document.addEventListener('shopify:section:load', (event) => {
      initHeader(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  function resetMarquee3k() {
    document.querySelectorAll('.marquee3k.is-init').forEach((el) => {
      const firstCopy = el.querySelector('.marquee3k__copy');
      if (!firstCopy) return;

      el.innerHTML = '';
      firstCopy.classList.remove('marquee3k__copy');
      firstCopy.style.display = '';
      el.classList.remove('is-init');
      el.appendChild(firstCopy);
    });
  }

  function initMarquee3k() {
    if (typeof Marquee3k === 'undefined') return;
    if (!document.querySelector('.marquee3k')) return;

    resetMarquee3k();
    Marquee3k.init();
  }

  function whenMarquee3kReady(callback) {
    if (typeof Marquee3k !== 'undefined') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  whenMarquee3kReady(initMarquee3k);

  document.addEventListener('shopify:section:load', () => {
    whenMarquee3kReady(initMarquee3k);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-marquee"] && !Shopify.designMode) return;
  try {
    
  function resetAllMarquee3k() {
    document.querySelectorAll('.marquee3k.is-init').forEach((el) => {
      const firstCopy = el.querySelector('.marquee3k__copy');
      if (!firstCopy) return;

      el.innerHTML = '';
      firstCopy.classList.remove('marquee3k__copy');
      firstCopy.style.display = '';
      el.classList.remove('is-init');
      el.appendChild(firstCopy);
    });
  }

  function initMediaMarquee3k() {
    if (typeof Marquee3k === 'undefined') return;
    if (!document.querySelector('.marquee3k')) return;

    resetAllMarquee3k();
    Marquee3k.init();
  }

  function whenMediaMarquee3kReady(callback) {
    if (typeof Marquee3k !== 'undefined') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  function syncFooterWithMediaMarquee() {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    const footerGroup =
      document.querySelector('.shopify-section-group-footer-group') || document.querySelector('[id*="footer-group"]');
    const previousSection = footerGroup ? footerGroup.previousElementSibling : null;
    const shouldBlend = Boolean(previousSection && previousSection.querySelector('.media-marquee--blend-footer'));

    footer.classList.toggle('footer--on-yellow', shouldBlend);
  }

  function pauseMediaMarqueeScroller(scroller) {
    if (!scroller || !window.MARQUEES) return;

    const marquee = window.MARQUEES.find((entry) => entry.element === scroller);
    if (!marquee) return;

    marquee.paused = true;
    marquee.pausable = false;
  }

  function onMediaMarqueePlayClick(event) {
    const button = event.target.closest('[data-media-marquee-play]');
    if (!button) return;

    const item = button.closest('.media-marquee__item');
    const video = item && item.querySelector('video');
    const section = button.closest('[data-media-marquee]');
    const scroller = section && section.querySelector('.marquee3k');

    if (!video) return;

    pauseMediaMarqueeScroller(scroller);
    item.classList.add('is-playing');
    video.setAttribute('controls', '');
    video.muted = false;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        video.muted = true;
        video.play();
      });
    }
  }

  function initMediaMarquee() {
    whenMediaMarquee3kReady(initMediaMarquee3k);
    syncFooterWithMediaMarquee();
  }

  document.addEventListener('click', onMediaMarqueePlayClick);
  initMediaMarquee();

  document.addEventListener('shopify:section:load', initMediaMarquee);
  document.addEventListener('shopify:section:unload', syncFooterWithMediaMarquee);
  document.addEventListener('shopify:section:reorder', syncFooterWithMediaMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-media-with-text-play]');
    if (!button) return;

    const media = button.closest('.media-with-text__media');
    const video = media && media.querySelector('video');
    if (!video) return;

    media.classList.add('is-playing');
    video.setAttribute('controls', '');
    video.muted = false;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        video.muted = true;
        video.play();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.quantity').forEach((quantity) => {
    const input = quantity.querySelector('.quantity__input');
    if (!input) return;

    quantity.querySelectorAll('[data-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = parseInt(button.dataset.quantityStep, 10);
        const min = parseInt(input.min, 10) || 1;
        const current = parseInt(input.value, 10) || min;
        input.value = Math.max(min, current + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
